import { ISlimApp } from '@biolibtech/biolib-js';

interface MatchInfo {
    app: ISlimApp;
    matchIndex: number;
    matchedFieldLength: number;
    popularityIndex: number;
}

function normalizeSearchString(str: string): string {
    return str.toLowerCase().replace(/[-_]/g, '');
}

function getMatchInfo(app: ISlimApp, normalizedQuery: string, popularityIndex: number): MatchInfo | null {
    const normalizedName = normalizeSearchString(app.name);
    const normalizedHandle = normalizeSearchString(app.account_handle);
    const nameIndex = normalizedName.indexOf(normalizedQuery);
    const handleIndex = normalizedHandle.indexOf(normalizedQuery);

    if (nameIndex === -1 && handleIndex === -1) {
        return null;
    }

    let matchIndex: number;
    let matchedFieldLength: number;

    if (nameIndex !== -1 && handleIndex !== -1) {
        if (nameIndex <= handleIndex) {
            matchIndex = nameIndex;
            matchedFieldLength = app.name.length;
        } else {
            matchIndex = handleIndex;
            matchedFieldLength = app.account_handle.length;
        }
    } else if (nameIndex !== -1) {
        matchIndex = nameIndex;
        matchedFieldLength = app.name.length;
    } else {
        matchIndex = handleIndex;
        matchedFieldLength = app.account_handle.length;
    }

    return { app, matchIndex, matchedFieldLength, popularityIndex };
}

export function filterPrefetchedApps(apps: ISlimApp[], query: string): ISlimApp[] {
    if (!query || query.length < 1) {
        return [];
    }
    const normalizedQuery = normalizeSearchString(query);

    const matches: MatchInfo[] = [];
    apps.forEach((app, index) => {
        const matchInfo = getMatchInfo(app, normalizedQuery, index);
        if (matchInfo) {
            matches.push(matchInfo);
        }
    });

    matches.sort((a, b) => {
        if (a.popularityIndex !== b.popularityIndex) {
            return a.popularityIndex - b.popularityIndex;
        }
        if (a.matchIndex !== b.matchIndex) {
            return a.matchIndex - b.matchIndex;
        }
        return a.matchedFieldLength - b.matchedFieldLength;
    });

    return matches.map((m) => m.app);
}
